<template>
  <MyHeader></MyHeader>
  <div class="page-bg">
  <div class="container py-10">
    <h1 class="text-3xl font-bold mb-4">{{ newsData.title }}</h1>
    <div class="text-gray-500 mb-6">
      <span>发布时间: {{ newsData.createdAt }}</span>
    </div>
    <div v-html="newsData.content || '暂无内容...'" class="prose max-w-none"></div>
  </div>
  </div>
  <MyFooter></MyFooter>
</template>

<script setup>
import MyHeader from "../components/MyHeader.vue";
import MyFooter from "../components/MyFooter.vue";
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { getNewsDetailApi } from "../api/site";

const route = useRoute();
const newsData = ref({});

async function getNewsDetail() {
  const id = route.params.id;
  try {
    const res = await getNewsDetailApi(id);
    newsData.value = res;
  } catch (error) {
    console.error('获取新闻详情失败:', error);
  }
}

onMounted(() => {
  getNewsDetail();
});
</script>

<style scoped>
.page-bg {
  background: #fff;
  padding: 1px 0 32px;
}
</style>